"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ApiClientFactory = void 0;
var operations_1 = __importDefault(require("./operations"));
var ApiClient_1 = require("./ApiClient");
var utils_1 = require("./utils");
var queries = operations_1.default.queries, mutations = operations_1.default.mutations, subscriptions = operations_1.default.subscriptions;
var ApiClientFactory = /** @class */ (function () {
    function ApiClientFactory() {
        this.make = function (link) {
            return new ApiClient_1.ApiClient({
                link: link,
                queries: queries,
                mutations: mutations,
                subscriptions: subscriptions,
                modifyVariables: utils_1.modifyVariables,
            });
        };
    }
    return ApiClientFactory;
}());
exports.ApiClientFactory = ApiClientFactory;
//# sourceMappingURL=ApiClientFactory.js.map